<template>
  <el-form
    @submit.native.prevent
    class="dsf-online-login-tab-plan"
    label-width="1.8rem"
    autocomplete="off"
    :disabled="disabled"
    :css-disabled="disabled"
  >
    <el-form-item label="用户名">
      <span slot="label">
        <i class="iconfont icon-person"></i>
        <span class="label-text label-text1">用户名</span>
      </span>
      <el-input
        v-model.trim="username"
        :disabled="loading"
        :placeholder="userNamePlaceholder"
        clearable
      >
      </el-input>
    </el-form-item>
    <el-form-item label="密   码">
      <span slot="label">
        <i class="iconfont icon-mine_xgmm"></i>
        <span class="label-text label-text1">密码</span>
      </span>
      <password-iframe-input
        v-model="password"
        placeholder="请输入密码"
        @keydown="keydown"
        :disabled="disabled"
      />
    </el-form-item>
    <el-form-item v-if="isShowToken">
      <template slot="label">
        <i class="iconfont icon-icon-message"></i>
        <span class="label-text label-text1">动态口令</span>
      </template>
      <el-input
        v-model.trim="token"
        :disabled="loading"
        :placeholder="tokenPlaceholder"
        clearable
      >
      </el-input>
    </el-form-item>
    <el-button
      class="btn-wrap"
      :loading="loading"
      native-type="submit"
      @click="submit"
    >
      登录
    </el-button>
  </el-form>
</template>

<script>
import PasswordIframeInput from "../../components/passwordInput/passwordIframeInput.vue";
export default {
  name: "TabPriceSurvey",
  components: {
    PasswordIframeInput,
  },
  data() {
    return {
      loading: false,
      username: "",
      password: "",
      token: "",
      isShowPassword: false,
      showPasswordClear: false,
    };
  },
  props: {
    isShowForgotPassword: {
      type: Boolean,
      default: true,
    },
    login: {
      type: Function,
      default: null,
    },
    userNamePlaceholder: {
      type: String,
      default: "请输入用户名",
    },
    passwordPlaceholder: {
      type: String,
      default: "请输入密码",
    },
    tokenPlaceholder: {
      type: String,
      default: "请输入动态口令",
    },
    customSetStateIsLogin: {
      type: Function,
      default() {
        return false;
      },
    },
    loginBefore: {
      default: null,
    },
    disabled: {
      default: false,
    },
  },
  computed: {
    showPassword() {
      if (this.isShowPassword) {
        return this.password;
      }
      return Array.from(new Array(this.password.length))
        .map(() => "*")
        .join("");
    },
    isTokenLogin() {
      return !this.loginBefore && dsf.config.setting_public_login_openToken;
    },
    isShowToken() {
      if (dsf.config.setting_public_statis_cloud_internal) {
        return false;
      }
      return !this.loginBefore;
    },
  },
  created() {},
  mounted() {},
  methods: {
    toForgotPassword() {
      dsf.layer.openWindow("#/pc/dsfa/platformhome/forgetPassword");
    },
    keydown(e) {
      if (e.keyCode == 13) {
        this.submit();
      }
    },
    submit() {
      dsf.cookies.remove("authorization_token");
      if (!this.login) {
        this.username = _.trim(this.username);
        this.password = _.trim(this.password);
        this.token = _.trim(this.token);
        if (this.username === "") {
          dsf.layer.message("用户名不能为空！", false);
          return;
        }
        if (this.password === "") {
          dsf.layer.message("密码不能为空！", false);
          return;
        }
        if (this.isTokenLogin && this.token === "") {
          dsf.layer.message("动态口令不能为空！", false);
          return;
        }
        this.loginHandler();
      }
    },

    loginHandler() {
      if (this.loginBefore) {
        this.loginBefore({
          username: this.username,
          password: this.password,
          code: this.token,
        });
        return;
      }
      if (!dsf.config.setting_public_smpublickey)
        return dsf.layer.message("没有获取到公钥", false);
      let password = dsf.sm2.encode(
        dsf.md5(dsf.md5(this.password)),
        dsf.config.setting_public_smpublickey
      );
      this.loading = true;
      this.$webAPI
        .login({
          userName: this.username,
          password: password,
          code: this.token,
          loginType: dsf.config.setting_public_login_openToken
            ? "token"
            : "account",
        })
        .then(({ data, success, message }) => {
          if (success) {
            if (data.userType == 2) {
              return this.saToLogin(data);
            } else {
              this.setStateIsLogin(data);
            }
          } else {
            dsf.layer.message(message, false);
          }
        })
        .catch((err) => {
          if (err) {
            dsf.layer.message(err.message || "未知错误", false);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 储存cookie登录状态
    setStateIsLogin(data) {
      if (data.redirectPath) {
        const obj = {
          path: data.redirectPath,
          g_t: dsf.cookies.get("g_token"),
          a: dsf.cookies.get("a"),
          b: dsf.cookies.get("b"),
          a_t: dsf.cookies.get($$config.setting_public_tokenkey),
          a_tt: $$config.setting_public_tokenkey,
        };
        location.replace(data.redirectPath);
      } else {
        dsf.layer.message("跳转路径不存在", false);
      }
    },
    saToLogin(data) {
      return dsf.http
        .get("/survey/assistant/getSurveyAssistantSsoUrl")
        .then((res) => {
          let { success, message, data } = res.data;
          if (success) {
            if (data) {
              location.replace(data);
            } else {
              dsf.layer.message("跳转路径不存在", false);
            }
          } else {
            dsf.layer.message(message, false);
          }
        });
    },
  },
};
</script>
